<div class="nt-loading-shade-middle" *ngIf="loading">
  <mat-spinner color="primary" *ngIf="loading"></mat-spinner>
</div>

<div class="wrapper">
  <!-- top navbar-->
  <app-header class="topnavbar-wrapper"></app-header>
  <!-- sidebar-->

  <app-sidebar class="aside-container"></app-sidebar>
  <!-- offsidebar-->
  <app-offsidebar class="offsidebar"></app-offsidebar>
  <!-- Main section-->

  <section class="section-container">
    <!-- Page content-->
    <app-breadcrumb style="height: 10px"></app-breadcrumb>
    <div class="content-wrapper">
      <router-outlet></router-outlet>
    </div>
  </section>
  <!-- Page footer-->
  <footer class="footer-container" app-footer></footer>
  <app-cookies-banner></app-cookies-banner>
</div>
